import Vue from 'vue'
import Vuex from 'vuex'


import user from './module/user'
import app from './module/app'
import common from './module/common'
import tagitr from './module/tagitr'
import levels from './module/levels'
import createPersistedState from 'vuex-persistedstate'; // 引入插件z
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    leveIdUploadedFileId: '',
    leveIdUploadedFileName: '',
    uInfo: '',
    token: '',
    menuList: [], // 菜单权限list
    tenantInfo: '', // 租户信息
    socketInfo: '', // socket 信息
    menuName: '',
    leftMenu: [],
    configura: {},
    businessId: '', // 全局调用的参数
    enumerationData: {}, // 枚举库
    dictypeData: {}, // 字典库
    titleText: '',
    taskNum: '', // 待办事项
    count: '', // 未读信息
    projectData: '',
    windowsOpen: {}, // 打开窗口

    defaultActive: sessionStorage.getItem("isactive") || '',

    shouldRefreshHandoverTypeList: false

  },
  mutations: {
    setLeveIdUploadedFileId(state, data) {
      console.log("leveIdUploadedFileId:", data)
      state.leveIdUploadedFileId = data
      sessionStorage.setItem('leveIdUploadedFileId', data)
    },
    setLeveIdUploadedFileName(state, data) {
      console.log("leveIdUploadedFileName:", data)
      state.leveIdUploadedFileName = data
      sessionStorage.setItem('leveIdUploadedFileName', data)
    },
    count(state, data) {
      state.count = data
      sessionStorage.setItem('count', JSON.stringify(data))
    },
    taskNum(state, data) {
      state.taskNum = data
      sessionStorage.setItem('taskNum', JSON.stringify(data))
    },
    titleText(state, data) {
      state.titleText = data
      sessionStorage.setItem('titleText', JSON.stringify(data))
    },
    configura(state, info) {
      let info1 = JSON.parse(JSON.stringify(info))
      state.configura = info1
    },
    set_businessId(state, info) {
      state.businessId = info
    },
    set_menuList(state, info) { // 登录成功获取用户菜单list
      state.menuList = info
      sessionStorage.setItem('menuList', JSON.stringify(info))
    },
    set_uInfo(state, info) {
      state.uInfo = info
      sessionStorage.setItem('uInfo', JSON.stringify(info))
    },
    del_uInfo(state) {
      state.uInfo = ''
      sessionStorage.removeItem('uInfo')
    },
    set_token(state, data) {
      state.token = data
      sessionStorage.setItem('token', data)
    },
    del_token(state) {
      state.token = ''
      sessionStorage.removeItem('token')
    },
    set_tenantInfo(state, data) {
      state.tenantInfo = data
      sessionStorage.setItem('tenantInfo', JSON.stringify(data))
    },
    del_tenantInfo(state, data) {
      state.tenantInfo = ''
      sessionStorage.removeItem('tenantInfo')
    },
    del_all(state, data) {
      state.projectData = ''
      state.uInfo = ''
      state.token = ''
      state.menuList = ''
      state.tenantInfo = ''
      sessionStorage.clear()
    },
    set_socketInfo(state, info) {
      state.socketInfo = info
      sessionStorage.setItem('socketInfo', JSON.stringify(info))
    },
    set_leftMenu(state, data) {
      state.leftMenu = data;
      sessionStorage.setItem('leftMenu', JSON.stringify(data))
    },
    set_menuName(state, data) {
      state.menuName = data
      sessionStorage.setItem('menuName', JSON.stringify(data))
    },
    set_menu_tree(state, data) {
      state.menuName = data
      sessionStorage.setItem('menu_treObj', JSON.stringify(data))
    },
    setEnumerationData(state, data) { // 设置枚举库
      state.enumerationData = data
      sessionStorage.setItem('enumerationData', JSON.stringify(data))
    },
    setDictypeData(state, data) { // 设置字典库
      state.dictypeData = data
      sessionStorage.setItem('dictypeData', JSON.stringify(data))
    },
    // 动态审批流 end
    set_pageCenter(state, val) {
      state.pageCenterType = val
      sessionStorage.setItem('pageCenterType', val)
    },
    // 自定义功能
    set_dynamicConfigObj(state, val) {
      state.dynamicConfigObj = val
      sessionStorage.setItem('dynamicConfigObj', JSON.stringify(val))
    },
    set_projectData(state, val) {
      state.projectData = val
      sessionStorage.setItem('projectData', JSON.stringify(val))
    },
    // 自定义功能
    set_windowsOpen(state, val) {
      if (val) {
        let str = new Date().getTime()
        state.windowsOpen = str
        window['newWindow_' + str] = window.open(val, str)
      } else {
        delete window['newWindow_' + state.windowsOpen]
        state.windowsOpen = null
      }
      // sessionStorage.setItem('windowsOpen', val)
    },

    // 后加的 显示路由中只有一个子路由的时候显示出父路由
    // setParentRouteName(state, name) {
    //   state.parentRouteName = name;
    // }

    // 修改刷新标志位的 mutation
    SET_SHOULD_REFRESH_HANDOVER_TYPE_LIST(state, value) {
      state.shouldRefreshHandoverTypeList = value;
    }

  },
  actions: {
    //
    configura(state, info) {
      state.commit('configura', info)
    },

    // 触发刷新的 action
    triggerHandoverTypeListRefresh({ commit }) {
      // 先将标志位设为 true
      commit('SET_SHOULD_REFRESH_HANDOVER_TYPE_LIST', true);
      // 为了避免一直处于刷新状态，短暂延迟后再将标志位设为 false
      setTimeout(() => {
        commit('SET_SHOULD_REFRESH_HANDOVER_TYPE_LIST', false);
      }, 100);
    }
  },
  modules: {
    user,
    app,
    common,
    tagitr,
    levels
  },
  plugins: [createPersistedState({  // 使用插件
    storage: window.localStorage // 设置为使用 localStorage
  })]
})
